// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card__LessonCard-module--r2uqX {
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    min-height: 300px;
    padding: var(--space-md);
    border: none;
    border-radius: var(--home-radius-xl);
    text-decoration: none;
    transition: transform 0.2s ease;
}

.card__LessonCard-module--r2uqX:hover {
    transform: translateY(-6px);
}

@media (prefers-reduced-motion: reduce) {
    .card__LessonCard-module--r2uqX {
        transition-duration: 0.01s;
    }
}

.top__LessonCard-module--BGBaf {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--space-sm);
}

.number__LessonCard-module--E7wW6 {
    font-size: var(--home-text-numeral);
    font-weight: 900;
    letter-spacing: -0.03em;
    line-height: 0.8;
}

.body__LessonCard-module--biX78 {
    display: flex;
    flex-direction: column;
    gap: var(--space-2xs);
    margin-top: auto;
}

.meta__LessonCard-module--tvyrb {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

.title__LessonCard-module--j6vJa {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.015em;
    line-height: 1.15;
}

.footer__LessonCard-module--h0KQF {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: var(--space-sm);
    border-top: 1.5px solid currentColor;
    opacity: 0.7;
    font-weight: 700;
    font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/LessonCard.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,oCAAoC;IACpC,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;IAC5B,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".card {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    min-height: 300px;\n    padding: var(--space-md);\n    border: none;\n    border-radius: var(--home-radius-xl);\n    text-decoration: none;\n    transition: transform 0.2s ease;\n}\n\n.card:hover {\n    transform: translateY(-6px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .card {\n        transition-duration: 0.01s;\n    }\n}\n\n.top {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: var(--space-sm);\n}\n\n.number {\n    font-size: var(--home-text-numeral);\n    font-weight: 900;\n    letter-spacing: -0.03em;\n    line-height: 0.8;\n}\n\n.body {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-2xs);\n    margin-top: auto;\n}\n\n.meta {\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n}\n\n.title {\n    font-size: 24px;\n    font-weight: 700;\n    letter-spacing: -0.015em;\n    line-height: 1.15;\n}\n\n.footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: var(--space-sm);\n    border-top: 1.5px solid currentColor;\n    opacity: 0.7;\n    font-weight: 700;\n    font-size: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card__LessonCard-module--r2uqX`,
	"top": `top__LessonCard-module--BGBaf`,
	"number": `number__LessonCard-module--E7wW6`,
	"body": `body__LessonCard-module--biX78`,
	"meta": `meta__LessonCard-module--tvyrb`,
	"title": `title__LessonCard-module--j6vJa`,
	"footer": `footer__LessonCard-module--h0KQF`
};
export default ___CSS_LOADER_EXPORT___;
